import { Radar } from "lucide-react";
import type { FactoryState, Section } from "../../types";
import { SectionHeader } from "../page";
import { ColorDot, ToneBadge } from "../status-badge";
import { AgentCard } from "./agent-card";

export function SectionGroup({
  section,
  state,
  onOpen,
}: {
  section: Section;
  state: FactoryState | undefined;
  onOpen: (id: string) => void;
}) {
  return (
    <section className="space-y-3">
      <SectionHeader
        title={
          <span className="flex items-center gap-2">
            <ColorDot color={section.color} className="size-2.5" />
            {section.name}
          </span>
        }
        count={section.agents.length}
        description={section.description}
        actions={
          section.detached && (
            <ToneBadge
              tone="violet"
              title="Off the line: these agents file Skynet issues, which arrive through intake"
            >
              <Radar /> Detached
            </ToneBadge>
          )
        }
      />
      <div className="grid gap-3 @3xl/main:grid-cols-2 @7xl/main:grid-cols-3">
        {section.agents.map((a) => (
          <AgentCard key={a.id} agent={a} state={state} onOpen={() => onOpen(a.id)} />
        ))}
      </div>
    </section>
  );
}
